import React from "react";

import { motion, useAnimation } from "framer-motion";
import { useInView } from "react-intersection-observer";

const drinks = [
  {
    title: "اسپرسو (Espresso)",
    image: "/images/espresso.jpg",
    description:
      "اسپرسو پایه‌ی اصلی بسیاری از نوشیدنی‌های قهوه است. اسپرسو یک روش عصاره‌گیری قهوه غلیظ و پرکافئین است که با عبور آب داغِ تحت فشار از میان دانه‌های آسیاب‌شده و فشرده قهوه به دست می‌آید. این نوشیدنی اصالتاً متعلق به کشور ایتالیا است و به دلیل سرعت بالا در آماده‌سازی، پایه و اساس بیشتر نوشیدنی‌های محبوب کافه‌ای محسوب می‌شود.",
  },
  {
    title: "ریسترتو (Ristretto)",
    image: "/images/ristretto.jpg",
    description:
      "ریسترتو غلیظ‌ترین و کوتاه‌ترین نسخه از شات اسپرسو است که با همان مقدار پودر قهوه اما با نصف مقدار آب و زمان عصاره‌گیری کوتاه‌تر تهیه می‌شود. کلمه ریسترتو در زبان ایتالیایی به معنای «محدود شده» یا «کوتاه شده» است که مستقیماً به محدود بودن حجم آب در این نوشیدنی اشاره دارد.",
  },
  {
    title: "دوپیو (Doppio)",
    image: "/images/doppio.jpg",
    description:
      "دوپیو (Doppio) در دنیای قهوه به معنای یک شات دوبل اسپرسو است. کلمه دوپیو در زبان ایتالیایی به معنای «دوبل» یا «دوبرابر» است. این نوشیدنی از عصاره‌گیری حدود ۱۴ تا ۱۸ گرم پودر قهوه تهیه می‌شود و در نهایت حدود ۶۰ میلی‌لیتر قهوه اسپرسو غلیظ به شما می‌دهد. گزینه‌ای ایده‌آل برای کسانی است که به دنبال انرژی بیشتر هستند.",
  },
  {
    title: "آمریکانو (Americano)",
    image: "/images/americano.jpg",
    description:
      "آمریکانو از ترکیب یک یا دو شات اسپرسو با آب داغ تهیه می‌شود و این نوشیدنی طعمی شبیه به قهوه دمی سنتی دارد اما به دلیل پایه اسپرسوی خود، از غلظت و ویژگی‌های عطر و طعمی غنی‌تری برخوردار است.",
  },
  {
    title: "لاته (Latte)",
    image: "/images/latte.jpg",
    description:
      " (Caffè latte) یک نوشیدنی محبوب بر پایه قهوه است که از ترکیب یک شات اسپرسو، مقدار زیادی شیر داغ و لایه نازکی از کف (فوم) شیر روی آن ساخته می‌شود. کلمه لاته در زبان ایتالیایی به معنای «شیر» است.",
  },
  {
    title: "کاپوچینو (Cappuccino)",
    image: "/images/cappuccino.jpg",
    description:
      "کاپوچینو یک نوشیدنی گرم و محبوب ایتالیایی بر پایه قهوه است که از ترکیب مساوی یا متوازن اسپرسو، شیر داغ بخار داده‌شده و لایه‌ای غنی از کف (فوم) شیر تهیه می‌شود. این نوشیدنی با طعم قوی قهوه و بافت نرم خود شناخته می‌شود.",
  },
  {
    title: "موکا (Mocha)",
    image: "/images/mocha.jpg",
    description:
      " نوعی نوشیدنی گرم بر پایه اسپرسو است که از ترکیب قهوه اسپرسو، شیر داغ و شکلات (سس یا پودر کاکائو) تهیه می‌شود و طعمی شیرین و شکلاتی دارد. این نوشیدنی شباهت زیادی به لاته دارد، با این تفاوت که در آن از شکلات استفاده می‌شود.",
  },
  {
    title: "ماکیاتو (Macchiato)",
    image: "/images/macchiato.jpg",
    description:
      "ماکیاتو یک نوشیدنی برمبنای قهوه اسپرسو است که واژه ایتالیایی آن به معنای «لکه‌دار» یا «نشان‌دار» است. این نام به این دلیل انتخاب شده است که اسپرسو با مقدار کمی شیر فوم‌گرفته‌شده لکه‌دار یا روشن می‌شود.",
  },
  {
    title: "فلت وایت (Flat White)",
    image: "/images/flatwhite.jpg",
    description:
      "فلت وایت شبیه لاته است اما با نسبت بالاتری از اسپرسو به شیر و فومی لطیف‌تر و نازک‌تر.  طعم قهوه در آن نسبت به شیرینی و حجم شیر، غالب‌تر و قوی‌تر از لاته است.",
  },
  {
    title: "آفوگاتو (Affogato)",
    image: "/images/affogato.jpg",
    description:
      "آفوگاتو ترکیبی از یک اسکوپ بستنی وانیلی با شات داغ اسپرسو است — ترکیبی دلپذیر از گرم و سرد. آفوگاتو یک دسر و نوشیدنی خوشمزه ایتالیایی است که از ریختن یک شات قهوه اسپرسو داغ روی یک اسکوپ بستنی (یا ژلاتو) وانیلی به دست می‌آید. کلمه آفوگاتو در زبان ایتالیایی به معنی «غرق‌شده» است، زیرا بستنی در قهوه داغ غرق می‌شود.",
  },
];

const DrinkCard = ({ drink }) => {
  const controls = useAnimation();
  const [ref, inView] = useInView({ triggerOnce: true, threshold: 0.2 });

  React.useEffect(() => {
    if (inView) {
      controls.start("visible");
    }
  }, [inView, controls]);

  const cardVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
  };

  return (
    <motion.div
      ref={ref}
      variants={cardVariants}
      initial="hidden"
      animate={controls}
      className="bg-[#fef9f5] rounded-xl p-4 shadow-md"
    >
      <img
        src={drink.image}
        alt={drink.title}
        className="w-full h-96 object-cover rounded-lg mb-3"
      />
      <h3 className="text-xl font-semibold text-amber-900 mb-2">{drink.title}</h3>
      <p className="text-stone-800 text-sm leading-relaxed text-justify">
        {drink.description}
      </p>
    </motion.div>
  );
};

export const CoffeeDrinksPage = () => {
  return (
    <div className="mb-4 text-black min-h-screen">
      <main className="pt-28 px-4 max-w-6xl mx-auto">
        <h1 className="text-xl font-bold mb-4 text-amber-950">
          معرفی تخصصی انواع نوشیدنی‌های بر پایه اسپرسو
        </h1>
        <p className="mb-8 text-stone-700 leading-relaxed text-justify text-sm">
          قهوه یکی از متنوع‌ترین نوشیدنی‌های جهان است. بر پایه یک شات اسپرسو، انواع مختلفی از نوشیدنی‌ها خلق می‌شود که هرکدام طعم، بافت و تجربه متفاوتی به همراه دارند. در ادامه، با محبوب‌ترین نوشیدنی‌های قهوه آشنا می‌شوید.
        </p>
        <div className="grid md:grid-cols-2 gap-6">
          {drinks.map((drink, index) => (
            <DrinkCard key={index} drink={drink} />
          ))}
        </div>
      </main>
    </div>
  );
};

export default CoffeeDrinksPage;
